import {BaseDocumentationGuard} from './base-documentation.guard';
import {SwalUtil} from '../../util/swal-util';
import {Injectable} from '@angular/core';
import {AccountState} from "../../states/account.state";

@Injectable({
  providedIn: 'root'
})
export class DocumentationGuard extends BaseDocumentationGuard {

  protected showMessage() {

    let accountStatus = this.store.selectSnapshot(AccountState.getAccountStatus);
    let userType = accountStatus.userType.id;
    let verificacionStatus = accountStatus.verificationStatus;
    let kycStatus = verificacionStatus.kyc;
    let documentosStatus = verificacionStatus.documentos;
    let infoAdicionalStatus = verificacionStatus.informacionAdicional;

    let msg = "";

    if(accountStatus.level.id != '0') {
      msg += "Debes completar las siguientes verificaciones para poder vender cheques: <br>";
      if(kycStatus != 'APPROVED') {
        msg += "<br>*Verificación de Identidad"
      }
      if(userType == 'JURIDICA' && documentosStatus != 'APPROVED') {
        msg += "<br>*Verificación de Datos"
      }
      if(infoAdicionalStatus != 'APPROVED') {
        msg += "<br>*Verificación de Información Adicional"
      }
    } else {
      msg += "Debes verificar tu E-mail para continuar";
    }
    SwalUtil.fireGenericHtmlMessage("Atención", msg);
  }
}
